export const TagDisplayIds = {
    expedited: 'Expedited',
} as const;
